import { ButtonGroup } from "../../components/button/ButtonGroup";
import styles from "../skjema.module.scss";
import buttonStyles from "../../components/button/button.module.scss";
import { useTranslation } from "react-i18next";
import Button from "../../components/button/Button";
import cn from "classnames";
import dayjs from "dayjs";

import { Languages } from "../../i18n/config";

const languages: Record<Languages, string> = {
  nb: "Bokmål",
  nn: "Nynorsk",
  en: "English",
};

const Spraakvelger = () => {
  const { t, i18n } = useTranslation("skjematekst");
  const changeLanguageHandler = (language: string) => {
    void i18n
      .changeLanguage(language)
      .then(() => localStorage.setItem("lng", language));

    dayjs.locale(language);
  };

  return (
    <div className={cn(styles.spraakvelger)} data-testid="spraakvelger">
      <sds-icon
        name={"public-material-outlined"}
        label={t("forside.spraakvelger.ariaLabel")}
      />
      <ButtonGroup>
        {Object.entries(languages).map(([lang, label]) => (
          <Button
            key={lang}
            buttonType={"tertiary"}
            size={"medium"}
            onClick={() => lang && changeLanguageHandler(lang)}
            aria-current={i18n.language === lang}
            style={i18n.language === lang ? buttonStyles.overrideTextBlack : ""}
            lang={lang}
            text={label}
            trackingName={`Språkvalg ${lang}`}
          />
        ))}
      </ButtonGroup>
    </div>
  );
};

export default Spraakvelger;
